import React, { useEffect, useState } from "react";
import { Form, FormGroup, Label } from "reactstrap";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { useNavigate } from "react-router-dom";
import {
  createVehicleDocument,
  deleteVehicleImage,
} from "../../services/VehicleService";
import { useTranslation } from "react-i18next";

const VehicleDocument = ({
  setActiveTab,
  vehicleProcessList = [],
  activeTab,
}) => {
  const [citizenCard, setCitizenCard] = useState(null);
  const { t } = useTranslation();

  const [certificate, setCertificate] = useState(null);
  const [singleCar, setSingleCar] = useState(null);
  const [modelImtt, setModelImtt] = useState(null);
  const [chassisNo, setChassisNo] = useState(null);
  const [taxAuthority, setTaxAuthority] = useState(null);
  const [otherFile, setOtherFile] = useState(null);

  const [previewUrls, setPreviewUrls] = useState({
    citizen_card_file: null,
    certificate_file: null,
    single_car_document_file: null,
    model_imtt_file: null,
    chassis_no_file: null,
    tax_authority_file: null,
    other_file: null,
  });
  const [showPreviews, setShowPreviews] = useState({
    citizen_card_file: false,
    certificate_file: false,
    single_car_document_file: false,
    model_imtt_file: false,
    chassis_no_file: false,
    tax_authority_file: false,
    other_file: false,
  });

  let vehicleId = localStorage.getItem("vehicleId");

  const navigate = useNavigate();

  const isImageFile = (file) => file && file.type.startsWith("image/");

  const validateFiles = () => {
    const files = [citizenCard, certificate, singleCar, modelImtt, chassisNo];
    const imageFiles = files.filter(isImageFile);
    return imageFiles.length >= 2;
  };

  useEffect(() => {
    if (
      Array.isArray(vehicleProcessList?.document_file) &&
      activeTab === "vehicle_documents"
    ) {
      const initializeData = () => {
        const documentTypes = [
          "citizen_card_file",
          "certificate_file",
          "single_car_document_file",
          "model_imtt_file",
          "chassis_no_file",
          "tax_authority_file",
          "other_file",
        ];

        const newPreviewUrls = {};
        const newShowPreviews = {};

        documentTypes.forEach((type) => {
          const docData = vehicleProcessList?.document_file?.find(
            (item) => item.document_type === type,
          );
          newPreviewUrls[type] = docData ? docData.document_file : null;
          newShowPreviews[type] = !!docData;
        });

        setPreviewUrls(newPreviewUrls);
        setShowPreviews(newShowPreviews);
        setCitizenCard(newPreviewUrls?.citizen_card_file);
        setCertificate(newPreviewUrls?.certificate_file);
        setSingleCar(newPreviewUrls?.single_car_document_file);
        setModelImtt(newPreviewUrls?.model_imtt_file);
        setChassisNo(newPreviewUrls?.chassis_no_file);
        setTaxAuthority(newPreviewUrls?.tax_authority_file);
        setOtherFile(newPreviewUrls?.other_file);
      };

      initializeData();
    }
  }, [vehicleProcessList, activeTab]);

  const handleFileChange = (e, fileType) => {
    const file = e.target.files[0];

    if (!file) {
      setPreviewUrls((prev) => ({ ...prev, [fileType]: null }));
      return;
    }

    // Allow only PDF for specific fields
    const pdfOnlyFields = ["tax_authority_file", "other_file"];

    if (pdfOnlyFields.includes(fileType) && file.type !== "application/pdf") {
      alert("Only PDF files are allowed for this document.");
      e.target.value = "";
      return;
    }

    const url = URL.createObjectURL(file);

    // Store both url + type
    setPreviewUrls((prev) => ({
      ...prev,
      [fileType]: {
        url: url,
        type: file.type,
      },
    }));

    // Your existing switch
    switch (fileType) {
      case "citizen_card_file":
        setCitizenCard(file);
        break;
      case "certificate_file":
        setCertificate(file);
        break;
      case "single_car_document_file":
        setSingleCar(file);
        break;
      case "model_imtt_file":
        setModelImtt(file);
        break;
      case "chassis_no_file":
        setChassisNo(file);
        break;
      case "tax_authority_file":
        setTaxAuthority(file);
        break;
      case "other_file":
        setOtherFile(file);
        break;
      default:
        break;
    }
  };

  // const handleRemoveImage = (name, id) => {

  //   setPreviewUrls((prevState) => ({
  //     ...prevState,
  //     [`${name}`]: null,
  //   }));

  //   setShowPreviews((prevState) => ({
  //     ...prevState,
  //     [`${name}`]: false,
  //   }));

  //   setRemovedImages((prevState) => ({
  //     ...prevState,
  //     [name]: id,
  //   }));

  //   if (id) {
  //     const data = { id };

  //     deleteVehicleImage(data)
  //       .then((response) => {
  //         toast.success(response.data.message);
  //         // Optionally handle successful removal
  //         // setActiveTab("vehicle_extra_info");
  //       })
  //       .catch((err) => {
  //         toast.error(Utils.getErrorMessage(err));
  //       });
  //   } else {
  //     console.error("ID is undefined. Cannot remove image.");
  //   }
  // };

  const togglePreview = (fileType) => {
    setShowPreviews((prev) => ({
      ...prev,
      [`${fileType}`]: !prev[`${fileType}`],
    }));
  };

  const handleVehicleDocumentForm = (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("citizen_card_file", citizenCard);

    formData.append("certificate_file", certificate);

    formData.append("single_car_document_file", singleCar);

    formData.append("model_imtt_file", modelImtt);

    formData.append("chassis_no_file", chassisNo);
    formData.append("tax_authority_file", taxAuthority);
    formData.append("other_file", otherFile);

    formData.append("vehicle_id", vehicleId);

    const hasFiles =
      citizenCard ||
      certificate ||
      singleCar ||
      modelImtt ||
      chassisNo ||
      taxAuthority ||
      otherFile;

    if (vehicleProcessList?.id) {
      const formData = new FormData();

      formData.append("citizen_card_file", citizenCard);

      formData.append("certificate_file", certificate);

      formData.append("single_car_document_file", singleCar);

      formData.append("model_imtt_file", modelImtt);

      formData.append("chassis_no_file", chassisNo);
      formData.append("tax_authority_file", taxAuthority);
      formData.append("other_file", otherFile);
      formData.append("vehicle_id", vehicleId);
      formData.append("uuid", vehicleProcessList.uuid);
    }

    if (hasFiles) {
      createVehicleDocument(formData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/vehicle-process");
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    } else {
      setActiveTab("vehicle_extra_info");
      navigate("/vehicle-process");
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card card-primary">
          <Form method="post" onSubmit={handleVehicleDocumentForm}>
            <div className="card-body">
              <div className="row justify-content-start mb-5 ms-1 me-1">
                {[
                  { name: "citizen_card_file", label: t("citizen_card") },
                  { name: "certificate_file", label: t("certificate") },
                  { name: "single_car_document_file", label: t("signleCar") },
                  { name: "model_imtt_file", label: t("model_imtt") },
                  { name: "chassis_no_file", label: t("chassis_number") },
                  { name: "tax_authority_file", label: t("tax_authority_file") },
                  { name: "other_file", label: t("other_file") },
                ].map(({ name, label }) => (
                  <React.Fragment key={name}>
                    <div className="col-md-4">
                      <div className="fileupload-content">
                        <div className="fileupload-content-2">
                          <FormGroup>
                            <Label className="col-form-label ml-2">
                              {label}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="inputFile"
                                  type="file"
                                  accept={
                                    name === "tax_authority_file" ||
                                    name === "other_file"
                                      ? "application/pdf"
                                      : ".jpg,.jpeg,.png,.pdf"
                                  }
                                  onChange={(e) => handleFileChange(e, name)}
                                />
                              </div>
                            </div>
                          </FormGroup>

                          <div
                            className="Ss"
                            style={{ marginTop: "43px", marginLeft: "5px" }}
                          >
                            <div
                              style={{ cursor: "pointer" }}
                              className="icon-circle"
                              onClick={() => togglePreview(name)}
                            >
                              <i className="bi bi-eye"></i>
                            </div>
                          </div>
                        </div>
                        {showPreviews[name] && previewUrls[name] && (
                          <div className="col-md-12 mt-3">
                            {(() => {
                              const fileData = previewUrls[name];

                              // If new uploaded file (object)
                              if (typeof fileData === "object") {
                                if (fileData.type === "application/pdf") {
                                  return (
                                    <iframe
                                      src={fileData.url}
                                      title={t("document")}
                                      style={{
                                        width: "500px",
                                        height: "214px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  );
                                }

                                return (
                                  <img
                                    src={fileData.url}
                                    alt="Preview"
                                    style={{
                                      width: "500px",
                                      height: "214px",
                                      objectFit: "cover",
                                      borderRadius: "6px",
                                    }}
                                  />
                                );
                              }

                              // If backend file (string URL)
                              if (typeof fileData === "string") {
                                if (fileData.toLowerCase().includes(".pdf")) {
                                  return (
                                    <iframe
                                      src={fileData}
                                      title={t("document")}
                                      style={{
                                        width: "500px",
                                        height: "214px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  );
                                }

                                return (
                                  <img
                                    src={fileData}
                                    alt="Preview"
                                    style={{
                                      width: "500px",
                                      height: "214px",
                                      objectFit: "cover",
                                      borderRadius: "6px",
                                    }}
                                  />
                                );
                              }

                              return null;
                            })()}
                          </div>
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
              <div className="back-footer">
                <div className="row align-items-center">
                  <div className="col-4">
                    <button
                      type="button"
                      className="next-button btn btn-secondary"
                      onClick={() => setActiveTab("vehicle_owner")}
                    >
                      <i className="bi bi-arrow-left"></i> {t("back")}
                    </button>
                  </div>
                  <div className="col-4 text-center">
                    <small style={{ color: "#9ca3af" }}>
                      {t("step_x_of_n", { current: 6, total: 6 })}
                    </small>
                  </div>
                  <div className="col-4 text-end">
                    <button type="submit" className="btn btn-primary nxt-btn">
                      {t("save_and_continue")}
                      <i className="bi bi-arrow-right ms-1"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default VehicleDocument;
